// extracted by mini-css-extract-plugin
export default {"container":"AudioFile_container__Lh5rn","box":"AudioFile_box__Q6CPD","remove":"AudioFile_remove__flAwA","error":"AudioFile_error__n8ZbF"};